import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "index",
      component: () => import("@/views/index")
    },
    {
      path: "/about",
      name: "about",
      component: () => import("@/views/about")
    },
    {
      path: "/periodical",
      name: "periodical",
      component: () => import("@/views/periodical")
    },
    {
      path: "/product",
      name: "product",
      component: () => import("@/views/product")
    },
    {
      path: "/dynamic",
      name: "dynamic",
      component: () => import("@/views/dynamic")
    },
    {
      path: "/case",
      name: "case",
      component: () => import("@/views/case")
    },
    {
      path: "/scheme",
      name: "scheme",
      component: () => import("@/views/scheme")
    },

    {
      path: "/dynDetail",
      name: "dynDetail",
      component: () => import("@/views/dyn-detail")
    },
    {
      path: "/cooperate",
      name: "cooperate",
      component: () => import("@/views/cooperate")
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js